import React from "react"
import Layout from "components/Layout"
import VideoBox from "../components/VideoBox"

function Contact() {
	const Video = ({ id, description, url }) => {
		return (
			<VideoBox
				style={{
					backgroundColor: "whitesmoke",
					boxSizing: "border-box",
				}}
				description={description}
				url={url}
				id={id}
			/>
		)
	}
	return (
		<div>
			<Layout>
				<h1>Video</h1>
				<Video
					id="5"
					url="https://www.youtube.com/embed/P_19OkwjwVs"
					description="Intro into me"
				/>
				<Video
					id="4"
					url="https://www.youtube.com/embed/khiNH1cLiA8"
					description="The Lockdown Loop"
				/>
				<Video
					id="2"
					url="https://www.youtube.com/embed/CxuW_i6WNC0"
					description="Asos x AR"
				/>
				<Video
					id="1"
					url="https://www.youtube.com/embed/cGcCCgOx9Mc"
					description="Dubai"
				/>
				<Video
					id="3"
					url="https://www.youtube.com/embed/kC-5ADsY_i8"
					description="Dubrovnik, Croatia"
				/>
			</Layout>
		</div>
	)
}
export default Contact
